import { render, staticRenderFns } from "./GgsnSubscriberLookup.vue?vue&type=template&id=a56fada0&scoped=true"
import script from "./GgsnSubscriberLookup.vue?vue&type=script&lang=js"
export * from "./GgsnSubscriberLookup.vue?vue&type=script&lang=js"
import style0 from "./GgsnSubscriberLookup.vue?vue&type=style&index=0&id=a56fada0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56fada0",
  null
  
)

export default component.exports